import React from "react";
import { connect } from "react-redux";

import * as actions from "../../store/actions";

const Success = ({ email, setPasswordResetModal }) => (
  <>
    <p>
      An email with the password reset link has been sent to{" "}
      <strong>{email}</strong>. Please follow the instructions there.
    </p>
    <button onClick={() => setPasswordResetModal(false)}>Close</button>
  </>
);

const mapDispatchToProps = (dispatch) => ({
  setPasswordResetModal: (show) =>
    dispatch(actions.setPasswordResetModal(show)),
});

export default connect(null, mapDispatchToProps)(Success);
